import { FC, PropsWithChildren, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = PropsWithChildren<{
  elementId: string;
  watch?: unknown;
}>;
const Portal: FC<PortalProps> = ({ children, elementId, watch }) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setElement(document.getElementById(elementId));

    return () => setElement(null);
  }, [elementId, watch]);

  return element ? createPortal(children, element, elementId) : null;
};

export default Portal;
